<ngb-alert *ngIf="errorMessage" type="danger" (close)="errorMessage = null">{{ errorMessage }}</ngb-alert>
<ng-container>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      <ng-container [ngSwitch]="modalType">
        <ng-container *ngSwitchCase="'raiseViolation'">
          <span> رفع مخالفة قيد رقم #{{ franchiseNo }} </span>
        </ng-container>
        <ng-container *ngSwitchCase="'raiseSuspension'">
          <span> رفع الإيقاف عن قيد رقم #{{ franchiseNo }} </span>
        </ng-container>
        <!-- <ng-container *ngSwitchCase="'raiseCancellation'">
            <span> رفع الإلغاء عن قيد رقم #{{ franchiseNo }} </span>
          </ng-container> -->
      </ng-container>
    </h4>
    <span (click)="close()">
      <i class="fa-solid fa-xmark cursor-pointer"></i>
    </span>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="reason">
            <ng-container [ngSwitch]="modalType">
              <ng-container *ngSwitchCase="'raiseViolation'">
                <span> سبب رفع المخالفة </span>
              </ng-container>
              <ng-container *ngSwitchCase="'raiseSuspension'">
                <span> سبب رفع الإيقاف </span>
              </ng-container>
              <!-- <ng-container *ngSwitchCase="'raiseCancellation'">
                  <span> اترك سبب لرفع الإلغاء </span>
                </ng-container> -->
            </ng-container>

            <span class="required"> * </span>
          </label>
          <textarea class="form-control" id="reason" #note placeholder=" اكتب هنا.. "></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="close()">
      رجوع
    </button>
    <button type="button" class="btn btn-primary" (click)="save(note)">
      <ng-continer *ngIf="modalType == 'raiseViolation'">
        رفع المخالفة
      </ng-continer>
      <ng-continer *ngIf="modalType == 'raiseSuspension'">
        رفع الإيقاف
      </ng-continer>
      <!-- <ng-continer *ngIf="modalType == 'raiseCancellation'">
          رفع الإلغاء
        </ng-continer> -->
    </button>
  </div>
</ng-container>